import { getDispatch } from '../store';
import { setLibraryGroupIdAction } from '../store/general/actions';
import { getUserStateStorage } from '../../common/utils/local-storage/user-state';

export class UserGroupEffects {

  public static setLibraryGroupId(groupId: number) {
    const dispatch = getDispatch();
    dispatch(setLibraryGroupIdAction(groupId));
    getUserStateStorage().setLibraryGroupId(groupId);
  }

}
